import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class SelectivePreloadingStrategy implements PreloadingStrategy {
	public preload(
		route: Route,
		load: () => Observable<unknown>,
	): Observable<unknown> {
		if (route.data && route.data['preload']) {
			console.warn(
				`%c [App Configuration]: selectively loading module - ${route.path}`,
				'color: #3b82f6; background-color: black; font-weight: bold',
			);
			return load();
		} else {
			return of(null);
		}
	}
}
